import { shopServiceType } from '@/commonTypes';
import styles from '../styles.module.css';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';

type ServicePriceProps = {
  data?: shopServiceType;
  currency?: string;
  label?: string;
  note?: string;
  status?: string;
};

export default function ServicePrice({
  data,
  label = 'هزینهٔ خدمت',
  note = 'دستمزد + مواد',
  status = 'قیمت قطعی',
}: ServicePriceProps) {
  return (
    <div className={styles.servicePriceContainer}>
      <div>
        <div className={styles.servicePricelabel}>{label}</div>

        <PriceSection value={data?.price} className={`${styles.priceRow}`} />
      </div>

      <div className={styles.servicePriceinfo}>
        <div className={styles.servicePricenote}>{note}</div>
        <div className={styles.servicePricestatus}>{status}</div>
      </div>
    </div>
  );
}
